import RequiredValidator from "@/validators/RequiredValidator";

export default class MailTemplateRules {

	public static readonly htmlTemplateRules = [
		(new RequiredValidator('mailTemplate.singular')).validationRule(),
	];

}
